import React from 'react';
import { browserHistory } from 'react-router';
import KioskUpdateBlock from '../KioskUpdateBlock';
import $ from 'jquery';
import HostInfo from '../../model/HostInfo';
import ReactSpinner from 'react-spinjs';
import * as actions from '../../redux/actions';

class KioskUpdatePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      result: {},
      progress: {},
      showMoreInfo: false,
    };
    this.goBack = this.goBack.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleToggleShowMoreInfo = this.handleToggleShowMoreInfo.bind(this);
    this.handleViewKioskUpdateHistory = this.handleViewKioskUpdateHistory.bind(this);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getKVSList());
  }

  handleUpdate(pullUpdate) {
    let { selectedHostInfoList, selectedKVS, dispatch } = this.props;

    if (!pullUpdate && selectedHostInfoList.length > 30) {
      alert('Currently, there is a limit of 30 concurrent update using SSH!');
      return;
    }

    let doUpdate = window.confirm('Confirm update?');
    if (!doUpdate) {
      return;
    }
    let {auth: {user}} = this.props;
    let kioskVersionSetName = selectedKVS.name;
    let createdBy = user.email;

    selectedHostInfoList.forEach((kiosk) => {
      let progress = this.state.progress || {};
      progress[kiosk.id] = true;
      this.setState({ progress }, () => {
        this.updateKiosk(kioskVersionSetName, kiosk, createdBy, pullUpdate, () => {
          delete progress[kiosk.id];
          this.setState({ progress });
          // refresh versions data
          dispatch(actions.fetchInfo(kiosk)).then(() => {
            dispatch(actions.selectedHostInfoId(kiosk.id));
          });
        });
      });
    });
  }

  updateKiosk(kioskVersionSetName, kiosk, createdBy, pullUpdate, onDoneCallback) {
    let ipaddr = kiosk.ip;
    let macAddress = kiosk.macAddress;
    let hostname = kiosk.hostname;
    let authType = kiosk.authType || 'ksk';
    let kioskId = kiosk.kioskId;
    let kioskName = kiosk.kioskName;
    let kioskType = kiosk.kioskType;
    let locationName = kiosk.locationName;
    let orgName = kiosk.orgName;

    let queryString = $.param({
      kioskVersionSetName,
      kioskId,
      kioskName,
      kioskType,
      locationName,
      orgName,
      hostname,
      ipaddr,
      macAddress,
      authType,
      createdBy,
      pullUpdate,
    });
    let url = '/api/update/kiosk?' + queryString;

    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.seenBytes = 0;

    // streaming based on https://hpbn.co/xmlhttprequest/
    xhr.onreadystatechange = () => {
      // console.log(Util.localDateTimeString(new Date()) + " state change.. state: " + xhr.readyState);

      if (xhr.readyState > 2) {
        let newData = xhr.response.substr(xhr.seenBytes);
        xhr.seenBytes = xhr.responseText.length;
        // console.log(host, "<<" + newData + ">>", "seenBytes: " + xhr.seenBytes);
        let result = this.state.result || {};
        result[kiosk.id] = result[kiosk.id] || '';
        result[kiosk.id] += newData;
        this.setState({ result });
      }

      if (xhr.readyState === 4) {
        onDoneCallback();
      }
    };

    xhr.addEventListener('error', function (e) {
      console.log(kiosk, 'error: ', e);
      let result = this.state.result || {};
      result[kiosk.id] = result[kiosk.id] || '';
      result[kiosk.id] += '\nRequest Error: ' + JSON.stringify(e);
      this.setState({ result });
      onDoneCallback();
    });

    xhr.send();
  }

  handleToggleShowMoreInfo() {
    this.setState({ showMoreInfo: !this.state.showMoreInfo });
  }

  goBack() {
    let { prevLocation } = this.props;
    let { progress, result } = this.state;
    let numInProgress = Object.keys(progress).length;
    if (numInProgress > 0) {
      alert('Update in progress!');
      return;
    }
    let numResult = Object.keys(result).length;
    if (numResult > 0) {
      let isOk = window.confirm('Result will be lost! Navigate away anyway?');
      if (!isOk) {
        return;
      }
    }
    // if last location from login page, go to home page
    if (prevLocation && /^\/(login|logout)/.test(prevLocation.pathname)) {
      browserHistory.push('/');
      return;
    }
    browserHistory.goBack();
  }

  handleViewKioskUpdateHistory(id, event) {
    event.stopPropagation();
    let { progress, result } = this.state;
    let numInProgress = Object.keys(progress).length;
    if (numInProgress > 0) {
      alert('Update in progress!');
      return;
    }
    let numResult = Object.keys(result).length;
    if (numResult > 0) {
      let isOk = window.confirm('Result will be lost! Navigate away anyway?');
      if (!isOk) {
        return;
      }
    }
    browserHistory.push(`/id/${id}/update-history`);
  }

  render() {
    let { selectedHostInfoList, selectedKVS, kvsList, kvsHistoryList } = this.props;
    let sortedList = selectedHostInfoList.sort(sortByOrgAndLoc);
    let { result, progress, showMoreInfo } = this.state;
    let inProgress = false;
    let numInProgress = Object.keys(progress).length;
    let buttonText = ` Update ${selectedHostInfoList.length} with kiosk-updater.sh`;
    let buttonText2 = `Update ${selectedHostInfoList.length} with SSH`;
    if (numInProgress > 0) {
      inProgress = true;
      buttonText = `Updating ${numInProgress} of ${selectedHostInfoList.length} Kiosks ...`;
      buttonText2 = buttonText;
    }
    let numResult = Object.keys(result).length;
    let doneAllUpdate = !inProgress && numResult === selectedHostInfoList.length && numResult > 0;

    return (
      <div className='kiosk-upgrade-page'>
        {inProgress && <ReactSpinner />}
        <div className='title-row user-title'>
          <div className='title-back cursor-pointer' onClick={this.goBack}>
            <i className='fa fa-chevron-left' />
          </div>
          <div className='title' style={{ paddingLeft: '10px', textAlign: 'center' }}>
            {doneAllUpdate ? 'Finish Updating ' : 'Update'} {selectedHostInfoList.length} Kiosks
            with {selectedKVS.name}
          </div>
        </div>

        {selectedKVS && selectedKVS.name && (
          <div
            className='pure-u-1'
            style={{ padding: '10px 20px', backgroundColor: 'white', marginBottom: 10 }}
          >
            <div className='pure-u-1-1' style={{ position: 'relative' }}>
              <h2 style={{ textAlign: 'left' }}>{selectedKVS.name}</h2>
              <div style={{ position: 'absolute', top: 0, right: 0 }}>
                <a href='javascript:void(0)' onClick={this.handleToggleShowMoreInfo}>
                  {showMoreInfo ? 'hide' : 'show'} kiosk versions
                </a>
              </div>
            </div>
            <div className='pure-u-3-24'>
              <span className='kvs-em'>printapi</span>
              <br />
              <span className='kvs-version'>{selectedKVS.printapi}</span>
            </div>
            <div className='pure-u-3-24'>
              <span className='kvs-em'>payapi</span>
              <br />
              <span className='kvs-version'>{selectedKVS.payapi}</span>
            </div>
            <div className='pure-u-3-24'>
              <span className='kvs-em'>capui</span>
              <br />
              <span className='kvs-version'>{selectedKVS.capui}</span>
            </div>
            <div className='pure-u-3-24'>
              <span className='kvs-em'>kioskprobe</span>
              <br />
              <span className='kvs-version'>{selectedKVS.kioskprobe}</span>
            </div>
            <div className='pure-u-3-24'>
              <span className='kvs-em'>kskapi</span>
              <br />
              <span className='kvs-version'>{selectedKVS.kskapi}</span>
            </div>
            <div className='pure-u-3-24'>
              <span className='kvs-em'>cafeapi</span>
              <br />
              <span className='kvs-version'>{selectedKVS.cafeapi}</span>
            </div>
            <div className='pure-u-2-24'>
              <span className='kvs-em'>heatwave</span>
              <br />
              <span className='kvs-version'>{selectedKVS.heatwave}</span>
            </div>
            <div className='pure-u-2-24'>
              <span className='kvs-em'>linuxdash</span>
              <br />
              <span className='kvs-version'>{selectedKVS.linuxdash}</span>
            </div>
            <div className='pure-u-2-24'>
              <span className='kvs-em'>ciscoamp</span>
              <br />
              <span className='kvs-version'>{selectedKVS.ciscoamp}</span>
            </div>
          </div>
        )}

        <div className='pure-g' style={{ marginBottom: 20 }}>
          {sortedList.map((h) => {
            h = new HostInfo(h);
            h.calculateKvsNames(kvsList, kvsHistoryList);
            return (
              <KioskUpdateBlock
                {...this.props}
                key={h.id}
                kiosk={h}
                selectedKVS={selectedKVS}
                result={result[h.id]}
                inProgress={progress[h.id]}
                showMoreInfo={showMoreInfo}
                onViewKioskUpdateHistory={this.handleViewKioskUpdateHistory.bind(this, h.id)}
              />
            );
          })}

          <div className='pure-u-6-24'></div>
          <div className='pure-u-5-24'>
            {!doneAllUpdate && (
              <button
                className='pure-button button-regular button-primary'
                onClick={this.handleUpdate.bind(this, true)}
                disabled={inProgress}
              >
                {buttonText}
              </button>
            )}
          </div>
          <div className='pure-u-2-24'></div>
          <div className='pure-u-5-24'>
            {!doneAllUpdate && (
              <button
                className='pure-button button-regular button-primary'
                onClick={this.handleUpdate.bind(this, false)}
                disabled={inProgress}
              >
                {buttonText2}
              </button>
            )}
          </div>
          <div className='pure-u-6-24'></div>
        </div>
      </div>
    );
  }
}

function sortByOrgAndLoc(k1, k2) {
  let org1 = k1.orgName ? k1.orgName.toLowerCase() : '';
  let org2 = k2.orgName ? k2.orgName.toLowerCase() : '';
  let loc1 = k1.locationName ? k1.locationName.toLowerCase() : '';
  let loc2 = k2.locationName ? k2.locationName.toLowerCase() : '';
  if (org1 < org2) return -1;
  if (org1 > org2) return 1;
  if (loc1 < loc2) return 1;
  if (loc1 > loc2) return -1;
  return 0;
}

export default KioskUpdatePage;



// WEBPACK FOOTER //
// ./src/components/pages/KioskUpdatePage.js